var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.placeholder,"value":_vm.value},on:{"change":_vm.changeHandler}},_vm._l((_vm.options),function(option){return _c('a-select-option',{attrs:{"value":option.key}},[_vm._v(_vm._s(option.label))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2fe4c0ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/CrystalSysSelector.vue
// module id = null
// module chunks = 